import { Component, input, Input } from '@angular/core';
import { CmsInstructionContent } from 'parkour-web-app-dto';
import { ParkourAccordionComponent } from '../../shared/components/parkour-accordion/parkour-accordion.component';
import { MakeReferencesAbsolutePipe } from '../../watwat/pipes/make-references-absolute.pipe';
import { ParkourImageComponent } from '@parkour/ui';

@Component({
  selector: 'parkour-instruction-content',
  standalone: true,
  imports: [ParkourAccordionComponent, MakeReferencesAbsolutePipe, ParkourImageComponent],
  templateUrl: './instruction-content.component.html',
})
export class InstructionContentComponent {
  @Input({ required: true }) instructions!: CmsInstructionContent[];
  public readonly initiallyActiveItem = input.required<string>();
  protected readonly JSON = JSON;
}
